import { enrolledUtilityProgramsCollection } from '@/reducers/enrolledUtilityPrograms'
import { ID } from '@/types/model'

export default function useEnrolledDeviceIds(utilityProgramId: ID | undefined) {
  const { data: enrolledPrograms, isLoadingOrIdle } =
    enrolledUtilityProgramsCollection.useFetch()

  const enrolledProgram = enrolledPrograms.find(
    (p) => p.utility_program.id === utilityProgramId,
  )

  const vehicleIds = (enrolledProgram?.vehicle_enrollments ?? []).map(
    (e) => e.vehicle_id,
  )
  const thermostatIds = (enrolledProgram?.thermostat_enrollments ?? []).map(
    (e) => e.thermostat_id,
  )
  const chargerIds = (enrolledProgram?.charger_enrollments ?? []).map(
    (e) => e.charger_id,
  )

  const deviceIds: ID[] = [...vehicleIds, ...thermostatIds, ...chargerIds]

  return { deviceIds, isLoading: isLoadingOrIdle }
}
